import { render, staticRenderFns } from "./wsFeed.vue?vue&type=template&id=afb5f2d4&scoped=true&"
import script from "./wsFeed.vue?vue&type=script&lang=js&"
export * from "./wsFeed.vue?vue&type=script&lang=js&"
import style0 from "./wsFeed.vue?vue&type=style&index=0&id=afb5f2d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb5f2d4",
  null
  
)

export default component.exports